import React from 'react';

export default function ReprSelectionPage() {
	return (
		<div className="h-full w-full flex flex-col justify-center items-center overflow-y-scroll">
			<h1 className="text-2xl font-bold">議員の選び方</h1>
			<img src="/selectrepr.gif" alt="議員の選び方" className="min-h-0 w-full h-auto" />
		</div>
	)
}	